export const refreshTypes = {
    page: '[REFRESH Saved] page active',
    setSavePageActive: '[REFRESH Saved] setSavePageActive',
}